module.exports = __webpack_public_path__ + "static/media/iconTransportF.8983ebee.svg";